import React from "react";
import clsx from "clsx";
import { CustomButton } from "../../../../../Components";
import { useSelectedTheme, useTranslate } from "../../../../../Hooks";

import useStyles from "../styles";

import { CheckIcon, PlusIcon } from "../../../../../assets/icons";

function OptionalField({ onClickHandler, fieldData }) {
  const { translate } = useTranslate("NewAgentsRotationCriteria");
  const { value, isActive, translationKey } = fieldData;
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const startIcon = isActive ? (
    <CheckIcon width="20" height="20" fill={palette.button.secondary_fg} />
  ) : (
    <PlusIcon width="20" height="20" fill={palette.button.secondary_fg} />
  );

  return (
    <CustomButton
      boxShadow="xs"
      className={clsx(styles.button, { [styles.activeField]: isActive })}
      size="xl"
      variant="outlined"
      color="secondary"
      onClick={(e) => {
        e.stopPropagation(); // prevents bubbling click events inside accordion
        onClickHandler(!isActive, value);
      }}
      startIcon={startIcon}
    >
      {translate(translationKey)}
    </CustomButton>
  );
}

export default OptionalField;
